import { getConstantsFor } from '../asyncAction';

export const LOAD_DELIVERY_OPTIONS = getConstantsFor('LOAD_DELIVERY_AREAS');
export const LOAD_BRANCH_AVAILABILTY = getConstantsFor('LOAD_BRANCH_AVAILABILTY');
export const LOAD_REGISTRATION_GIFTS_FROM_BRANCH = getConstantsFor('LOAD_REGISTRATION_GIFTS_FROM_BRANCH');
